import { render, staticRenderFns } from "./positionEdit.vue?vue&type=template&id=7fafc777&scoped=true"
import script from "./positionEdit.vue?vue&type=script&lang=js"
export * from "./positionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fafc777",
  null
  
)

export default component.exports